<template>
  <div class="tag-box">
    <Tag
      v-for="tag in candidateTags"
      :key="tag.id"
      :id="tag.id"
      :name="tag.name"
      :effect="tag.my_tag == '0' ? 'dark' : 'light'"
      @close="removeTag($event, tag.id)"
    />

    <span
      class="el-tag new-tag el-tag--small el-tag--dark"
      v-if="tagFormVisible"
      ref="newTag"
      @click="focus"
    >
      <div class="new-tag__area">
        <div
          ref="input"
          class="new-tag__area-input"
          type="text"
          contenteditable
          autofocus
          @input="input($event)"
          @focus="focus"
        ></div>
        <i class="el-tag__close el-icon-close" @click="clear"></i>
      </div>
    </span>
    <div
      v-if="tagFormVisible && tagForm.tag_name && focused"
      ref="tagsPopper"
      class="el-select-dropdown el-popper tags-popper"
    >
      <div v-if="visibleTagBtn && !loading" class="add-tag-btn">
        <el-radio-group v-model="tagForm.my_tag" @change="createTag">
          <el-radio v-if="accessButtons.includes('all_tag')" label="0">
            Общий тег
          </el-radio>
          <el-radio v-if="accessButtons.includes('my_tag')" label="1">
            Личный тег
          </el-radio>
        </el-radio-group>
      </div>
      <div
        v-for="(tag, i) in filterList"
        v-show="!loading"
        :key="i"
        :label="tag.name"
        :value="tag.id"
        class="el-select-dropdown__item"
        @click="selectTag(tag)"
      >
        <span>
          {{ formatHtml(tag.name) }}
        </span>
      </div>
      <p v-if="!loading" slot="empty" class="el-select-dropdown__empty">
        {{ noTagMatches }}
      </p>
      <Loader class="tags-loader" v-show="loading" />
    </div>
    <form v-show="false" id="tagForm">
      <input
        v-for="(val, key) in tagParams"
        :key="key"
        type="hidden"
        :name="key"
        :value="val"
      />
      <input
        v-if="tagAction === ACTION.ADD_TAG_TO_CANDIDATE"
        type="hidden"
        name="candidate_id"
        :value="candidateId"
      />
      <input
        v-if="tagAction === ACTION.ADD_TAG_TO_CANDIDATE"
        type="hidden"
        name="tag_id[]"
        :value="tagForm.tag_id"
      />
      <input
        v-if="tagAction === ACTION.CREATE_TAG"
        type="hidden"
        name="tag_name"
        :value="tagForm.tag_name"
      />
      <input
        v-if="tagAction === ACTION.CREATE_TAG"
        type="hidden"
        name="my_tag"
        :value="tagForm.my_tag"
      />
    </form>
  </div>
</template>

<script>
import { store } from '@/store';
import { RadioGroup, Radio } from 'element-ui';
import { getController, postController } from '@/controllers/request.js';
import { MODULE, ACTION } from '@/utils/constants';
import { mixin, form } from '@/utils/mixins';
import Tag from 'Elements/Tag/Tag';
import Loader from 'Elements/Loader/Loader';

export default {
  mixins: [mixin, form],
  props: {
    candidateId: String,
    field: Object
  },
  data() {
    return {
      ACTION,
      visibleTagBtn: false,
      tagParams: {
        module: MODULE.HRPAC_TAGS,
        jsqon_return: 1,
        to_pdf: true
      },
      tags: [],
      candidateTags: [],

      tagForm: {},
      tagAction: '',
      loading: false,
      focused: false,
      filterList: [],
      accessButtons: []
    };
  },
  created() {
    if (this.field.visual_value?.length && !this.hidden(this.field)) {
      this.candidateTags = this.field.visual_value;
    }

    if (this.field.visual_value?.length) {
      this.tags = this.field.visual_value;
    }

    this.getButtonsAccess();
  },
  mounted() {
    document.addEventListener(
      'click',
      function (e) {
        if (!this.tagFormVisible) return;
        if (e.target.closest('.new-tag')) return;

        if (
          e?.path &&
          !e.path.filter(
            el => el.className == 'el-select-dropdown el-popper tags-popper'
          ).length
        ) {
          this.focused = false;
        }
      }.bind(this)
    );
  },
  beforeDestroy() {
    this.closeForm();
  },
  computed: {
    noTagMatches() {
      return !this.filterList.length && this.tags.length
        ? 'Не найдено...'
        : !this.tags.length
        ? 'Справочник пуст'
        : '';
    },
    tagFormVisible() {
      return store.state.candidate.visible.tagForm || false;
    },
    requestSent: {
      get() {
        return store.state.common.requestSent;
      },
      set(val) {
        store.commit('common/setRequestState', val);
      }
    }
  },
  methods: {
    sortedListByAZ(list = []) {
      return list.sort((a, b) => a.name.localeCompare(b.name));
    },
    async getOptions(search_string = '') {
      const perPage = 50;
      const iteration =
        0 || this.tags.length - this.candidateTags?.length <= 0
          ? 0
          : (this.tags.length - this.candidateTags?.length) / perPage;
      const params = {
        module: 'HRPAC_CANDIDATES',
        to_pdf: true,
        candidate_id: this.candidateId,
        action: 'get_rel_fields_values',
        iteration: Math.ceil(iteration) || 0,
        field: 'tags_ids',
        search_string: search_string.trim()
      };

      const { data } = await getController({ params });
      if (!data) return;

      this.loadMoreNum = 0;
      this.checkOptions = [];
      let keyOptions = [];
      if (this.options?.length) {
        for (let i in this.options) {
          keyOptions.push(this.options[i].id);
          if (this.tags && !this.tags.includes(this.options[i])) {
            this.tags.unshift(this.options[i]);
          }
        }
      }

      for (let key in data) {
        this.loadMoreNum++;

        if (typeof data[key] == 'object') {
          if (keyOptions.indexOf(data[key].id) == -1) {
            const params = {
              id: data[key].id,
              name: this.formatHtml(data[key].name)
            };

            if (data[key].my_tag) {
              params.my_tag = data[key].my_tag;
            }

            if (data[key].sub_text) {
              params.sub_text = this.formatHtml(data[key].sub_text);
            }

            this.checkOptions = [...this.checkOptions, params];
          }
        } else if (typeof data[key] == 'string') {
          const value = this.formatHtml(data[key]);
          if (keyOptions.indexOf(key) == -1) {
            this.checkOptions = [
              ...this.checkOptions,
              { id: key, name: value }
            ];
          }
        }
      }

      this.tags = [...this.tags, ...this.checkOptions];

      return this.tags;
    },
    addTag() {
      if (this.tagForm.tag_id && !this.requestSent) {
        this.requestSent = true;
        const form = document.getElementById('tagForm');
        const formData = new FormData(form);
        formData.set('action', this.tagAction);
        postController({ options: formData })
          .then(resp => {
            if (resp.data && !resp.data.error) {
              const tag = this.tags.find(
                ({ id }) => id === this.tagForm.tag_id
              );
              const addedTag = {
                id: tag.id,
                name: tag.name,
                my_tag: tag.my_tag
              };

              this.candidateTags.push(addedTag);
              this.tagForm = {};
              this.closeForm();
            } else throw 'Возникла ошибка при добавлении тегов';
          })
          .catch(err =>
            this.catchError(
              err,
              'Возникла ошибка при добавлении тегов',
              'add tag'
            )
          )
          .finally(() => {
            this.loading = false;
            this.tagAction = '';
            this.requestSent = false;
            this.focused = false;
          });
      }
    },
    createTag() {
      this.tagAction = ACTION.CREATE_TAG;
      if (!this.requestSent && this.tagForm.tag_name) {
        this.requestSent = true;
        this.loading = true;
        const form = document.getElementById('tagForm');
        const formData = new FormData(form);
        formData.set('action', this.tagAction);

        postController({ options: formData })
          .then(resp => {
            if (resp.data && !resp.data.error) {
              const id = resp.data[0].tag_id;
              const newTag = {
                id,
                my_tag: this.tagForm.my_tag,
                name: this.tagForm.tag_name
              };

              this.tags.push(newTag);

              this.$set(this.tagForm, 'tag_id', id);
              this.$set(this.tagForm, 'tag_name', '');
              this.$set(this.tagForm, 'my_tag', '');
              this.visibleTagBtn = false;
              this.requestSent = false;
              this.tagAction = ACTION.ADD_TAG_TO_CANDIDATE;
              this.$nextTick(() => this.addTag());
            } else throw 'Возникла ошибка при создании тега';
          })
          .catch(err =>
            this.catchError(
              err,
              'Возникла ошибка при создании тега',
              'create tag'
            )
          )
          .finally(() => {
            this.tagAction = '';
            this.requestSent = false;
          });
      }
    },
    removeTag(e, id) {
      if (!this.requestSent) {
        this.requestSent = true;
        this.tagAction = ACTION.REMOVE_TAG_FROM_CANDIDATE;

        if (id) {
          const formData = new FormData();
          const el = e.target.closest('.el-tag');
          const loader = `<div class="el-loading-spinner"><svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle></svg></div>`;

          el.innerHTML += loader;
          formData.set('action', this.tagAction);
          formData.set('candidate_id', this.candidateId);
          formData.set('tag_id', id);

          for (let key in this.tagParams) {
            formData.set(key, this.tagParams[key]);
          }

          postController({ options: formData })
            .then(resp => {
              if (resp.data && !resp.data.error) {
                this.candidateTags = this.candidateTags.filter(
                  tag => tag.id !== id
                );
                this.$set(this.tagForm, 'tag_id', '');
              } else throw 'Возникла ошибка при удалении тега';
            })
            .catch(err =>
              this.catchError(
                err,
                'Возникла ошибка при удалении тега',
                'remove tag'
              )
            )
            .finally(() => {
              this.requestSent = false;
              this.tagAction = '';
            });
        }
      }
    },
    hasMyTag(tagId) {
      return (
        this.tags.filter(({ id, my_tag }) => id === tagId && Number(my_tag))
          .length > 0
      );
    },
    handleChangeTag(e) {
      if (e.inputType == 'insertParagraph') {
        e.preventDefault();
        return;
      }
      this.tagAction = ACTION.CREATE_TAG;
      const query = !this.candidateTags.find(
        ({ name }) => name === e.target.innerHTML
      );
      this.visibleTagBtn = e.target.innerHTML ? query : false;
    },
    async filter(e) {
      this.tags = [];
      this.filterList = await this.getOptions(e);
      //если при поиске найден тег полностью совпадающий с введённым, то скрываем свитчеры
      this.visibleTagBtn =
        !this.filterList.find(({ name }) => name == e) &&
        !this.candidateTags.find(({ name }) => name === e);

      this.calcPopperCoords();
      this.loading = false;
    },
    input(e) {
      this.focused = true;
      this.loading = true;
      this.$set(this.tagForm, 'tag_name', e.target.textContent);
      this.handleChangeTag(e);
      //если пользователь вводит название тега слишком быстро,
      //то если риск наложения результатов предыдущего запроса на последний
      //+ большое кол-во запросов влияет на производительность
      //=> при вводе каждого символа запускается таймер и если в течение
      //следующих 2 секунд пользователь ничего не ввёл, то ищем совпадения
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        clearTimeout(this.timer);
        this.filter(e.target.textContent);
      }, 2000);
    },
    focus() {
      this.focused = true;
      this.calcPopperCoords();
    },
    selectTag(tag) {
      this.loading = true;
      this.tagAction = ACTION.ADD_TAG_TO_CANDIDATE;
      this.$set(this.tagForm, 'tag_id', tag.id);
      this.$set(this.tagForm, 'my_tag', tag.my_tag);
      this.$nextTick(() => this.addTag());
    },
    clear() {
      this.focused = false;
      this.tagAction = '';
      this.tagForm = {};
      this.closeForm();
    },
    closeForm() {
      store.commit('candidate/setVisibleElem', {
        elem: 'tagForm',
        visible: false
      });
    },
    calcPopperCoords() {
      this.$nextTick(() => {
        const newTag = this.$refs.newTag;
        const popper = this.$refs.tagsPopper;
        if (!popper) return;
        popper.style = 'left:' + newTag.offsetLeft + 'px';
      });
    },
    addIndentToTags() {
      const tagsEl = document.querySelectorAll('.tag-box .el-tag');
      for (let i = 0; i < tagsEl.length; i++) {
        tagsEl[i].classList.remove('el-tag--marginTop');
        if (
          i !== 0 &&
          tagsEl[i].getBoundingClientRect().y >
            tagsEl[0].getBoundingClientRect().y
        ) {
          tagsEl[i].classList.add('el-tag--marginTop');
        } else {
          tagsEl[i].classList.remove('el-tag--marginTop');
        }
      }
    },
    async getButtonsAccess() {
      const url = 'index.php?module=HRPAC_TAGS&action=create_buttons';

      const { data } = await getController({ url });
      if (!data || !data.allowed_buttons) return;
      this.accessButtons = data.allowed_buttons || [];
    }
  },
  updated() {
    this.addIndentToTags();
  },
  watch: {
    'candidateTags.length': function () {
      this.candidateTags = this.sortedListByAZ(this.candidateTags);

      if (this.tagAction === ACTION.REMOVE_TAG_FROM_CANDIDATE) {
        setTimeout(() => {
          this.calcPopperCoords();
          this.addIndentToTags();
        }, 400);
      }
    },
    tagFormVisible: function () {
      if (this.tagFormVisible) {
        this.$nextTick(() => this.$refs.input.focus());
      }
    }
  },
  unmounted() {
    document.removeEventListener('click');
  },
  components: {
    Tag,
    'el-radio-group': RadioGroup,
    'el-radio': Radio,
    Loader
  }
};
</script>

<style lang="scss">
.tags {
  width: 100%;
  display: inline-block;
  overflow: hidden;

  & > .el-button {
    margin-right: 5px;
    margin-bottom: 10px;
  }

  .el-collapse {
    border: none;
    clear: both;
  }

  .el-collapse-item {
    &__wrap {
      border: none;
    }

    & > div:first-child {
      display: none;
    }

    &__content {
      padding: 0;
      font-size: 1em;
    }
  }
}

.saved-tags {
  display: flex;
  flex-wrap: wrap;
  row-gap: 0.5em;
  position: relative;

  .el-tag {
    position: relative;
    cursor: default;
  }

  .el-loading-spinner {
    margin-top: -11px;

    .circular {
      width: 22px;
      height: 22px;
    }
  }
}

.tag-box {
  margin-bottom: 16px;

  .el-tag {
    &:not(:last-of-type) {
      margin-right: 8px;
    }

    &--marginTop {
      margin-top: 10px;
    }

    &:last-of-type {
      margin-right: 0;
    }
  }
}

.tag-box .new-tag {
  background: $blue40;
  border-color: $blue40;
  position: relative;
  padding: 2px 28px 2px 8px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 4px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  max-width: 100%;
  overflow: hidden;
  font-size: 14px;
  line-height: 20px;
  display: inline-block;
  vertical-align: bottom;

  &__area {
    display: flex;
    align-items: center;

    &-input {
      outline: none;
      color: $white;
      display: flex;
      min-width: 10px;
    }
  }

  & > input {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    overflow: hidden;
    max-width: calc(100% - 16px);
  }

  .el-tag__close {
    content: url('../../../assets/img/close.svg') !important;
    color: $white;
    position: absolute;
    right: 6px;
    top: 4px;
    height: 16px !important;
    width: 16px !important;
    transform: none;
  }

  .el-icon-close:hover {
    background: transparent;
    color: $white;
  }

  .el-icon-close::before {
    content: none;
  }

  &.el-tag--marginTop {
    margin-top: 10px;
  }
}

.tag-box .new-tag > input {
  width: 10px;
  height: 100% !important;
  background: inherit;
  border: none !important;
  padding: 0 !important;
}

.el-select-dropdown.el-popper.tags-popper {
  margin: 0;
  border: 1px solid $black-20;
  border-radius: 4px;
  box-shadow: 0px 7px 9px rgba(0, 0, 0, 0.04);
  width: 264px;
  max-height: 350px;
  overflow: auto;
  display: grid;

  & > .tags-loader {
    display: flex;
    justify-self: center;
    padding: 12px;
  }

  .el-radio__inner:after {
    height: 8px;
    width: 8px;
  }

  .add-tag-btn {
    padding: 12px 12px 8px;
    display: flex;
    justify-content: center;
    align-items: center;

    .el-radio {
      height: 40px;
      background: $grey8;
      border-radius: 4px;
      margin-right: 0 !important;
      width: 100%;
      padding: 8px 12px;

      &:not(:last-child) {
        margin-bottom: 3px;
      }

      &__input {
        margin-right: 12px;
      }

      &__label {
        margin-left: 0;
        font-size: 14px;
        line-height: 24px;
        color: $grey80;
      }

      &-group {
        width: 100%;
      }
    }
  }

  .el-select-dropdown__empty {
    color: $black-60;
  }

  .el-select-dropdown__item {
    height: 48px;
    line-height: 20px;
    padding: 14px 12px !important;

    span {
      font-size: 14px;
      line-height: 20px;
      color: $grey80;
      background: inherit;
    }
  }
}
</style>
